import { environment } from '@lla-platform/core/core-util'

export const WORK_ORDERS_API_URL = {
  summary: `${environment.apiUrl}/workorders/summary`,
  exportSummary: `${environment.apiUrl}/workorders/summary/export`,
  list: `${environment.apiUrl}/workorders/filters`,
  exportList: `${environment.apiUrl}/workorders/filters/export`
}
